// extracted by mini-css-extract-plugin
export const menu = "StickyCruiseMenu-module--menu--3NuNA";
export const summary = "StickyCruiseMenu-module--summary--c8hA3";
export const menuContainer = "StickyCruiseMenu-module--menu-container--1BdJN";
export const nav = "StickyCruiseMenu-module--nav--5295L";
export const navItem = "StickyCruiseMenu-module--nav-item--1QFHQ";
export const navItemSelected = "StickyCruiseMenu-module--nav-item-selected--2IlOj";
export const menuSticky = "StickyCruiseMenu-module--menu-sticky--3ZJHl";